export const MEASUREMENT_PRECISION_EXACT = { code: '=', id: 0 };
export const MEASUREMENT_PRECISION_TRACES = { code: 'traces', id: 3 };
